module.exports = __webpack_public_path__ + "static/img/github.a1e0a262.svg";